import {CardMedia} from '@mui/material';
import {getCardBackgroundImage} from 'presentation/utils';
import React from 'react';
import {CustomFooterProps} from './types';

export default function CustomFooter({
	flPlanoIntegrado,
	planType,
	cdModeloCarteira,
	cdParceiroLogo,
}: CustomFooterProps) {
	const background = getCardBackgroundImage({
		planType,
		isIntegrated: flPlanoIntegrado,
		cdModeloCarteira,
		cdParceiroLogo,
	});

	return <CardMedia sx={{height: 45}} image={background} title="Tarjeta carteirinha" />;
}
